<template>
    <div class="quarter-bank">
        <el-form :inline="true" :model="formInline" class="demo-form-inline select-wrap" :size="GCONFIG.styleElFormSize" >
            <el-form-item>起始周：
                <el-date-picker
                        v-model="weekValue"
                        type="week"
                        format="yyyy 第 WW 周" ref="week" placeholder="选择起始周" value-format="yyyy-MM-dd"
                        :picker-options="{'firstDayOfWeek': 1}" >
                </el-date-picker>
            </el-form-item>
            <el-form-item>结束周：
                <el-date-picker
                        v-model="weekValue1"
                        type="week"
                        format="yyyy 第 WW 周" ref="week" placeholder="选择结束周" value-format="yyyy-MM-dd"
                        :picker-options="{'firstDayOfWeek': 1}" >
                </el-date-picker>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="getWeekEndfinshList">查询</el-button>
                <el-button type="success" @click="getWeekRedExcelData">下载数据</el-button>
            </el-form-item>

        </el-form>

        <el-table :data="WeekEndfinshList" stripe border center :size="GCONFIG.styleTableSize" style="margin: 18px 0">
            <el-table-column type="index" label="序号" width="50"></el-table-column>
            <el-table-column label="期次" prop="periodName" sortable></el-table-column>
            <el-table-column label="部门" prop="deptName" sortable></el-table-column>
            <el-table-column label="姓名" prop="userName" sortable></el-table-column>
            <el-table-column label="连续完成次数(截止下周一14:00)" prop="totalFinishCount" sortable></el-table-column>
            <el-table-column label="连续完成工时数(小时)" prop="finishWorkhour" sortable></el-table-column>

        </el-table>
    </div>
</template>

<script>

import {downloadExcelWeek} from '@/api/api';
    //定义组件
    export default {
        data() {
            return {
                formInline: {
                    currentPage: 1,
                    pageSize: 50,
                    classId:9,
                    periodIds:[],
                },
                weekValue:this.getNewDay(-7),
                weekValue1:this.getNewDay(0),
                WeekEndfinshList:[],
            }
        },
        computed:{

        },
        props:['sectionClassId'],
        //挂载时候执行
        mounted() {
            this.getWeekEndfinshList()
        },
        methods: {
            getWeekEndfinshList() {
                var periodIds=this.weekValue+","+this.weekValue1;
                this.$store.dispatch('getWeekEndfinshList',{periodIds:periodIds}).then(res=>{
                    console.log(res)
                    this.WeekEndfinshList = res
                })
            },
            getNewDay( days) {
                var year=new Date().getFullYear();
                var month=new Date().getMonth()+1;
                var day=new Date().getDate();
                var hours=new Date().getHours();
                var week=new Date().getDay();
                if(week==0){
                    week=7;
                }
                if((week==5&& hours>=12)||week>5)
                {
                    days=0;
                }else{
                    days=-7;
                }
                var nDate = new Date(month + '-' + day+ '-' + year); //转换为MM-DD-YYYY格式
                var millSeconds = Math.abs(nDate) + (days * 24 * 60 * 60 * 1000);
                var rDate = new Date(millSeconds);
                var year = rDate.getFullYear();
                var month = rDate.getMonth() + 1;
                if (month < 10) month = "0" + month;
                var date = rDate.getDate();
                if (date < 10) date = "0" + date;
                return (year + "-" + month + "-" + date);
            },
            getWeekRedExcelData(){
                var periodIds=this.weekValue+","+this.weekValue1;
                window.open(`${downloadExcelWeek}?isFinish=1&periodIds=`+periodIds)
            }

        },

    }
</script>



// WEBPACK FOOTER //
// src/components/cooperative/weekEndFormRed.vue